export default class LandingGrid extends HTMLElement {
  constructor() {
    super();
    const $swipers = this.querySelectorAll(".swiper");
    $swipers.forEach((swiper) => {
      new Swiper(swiper, {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: false,
      });
    });
  }
}

